export const pageview = (): void => {
  (window as any).fbq('track', 'PageView');
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name, options = {}): void => {
  (window as any).fbq('track', name, options);
};
